/* eslint-disable */
import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { toast } from 'react-toastify';

// components
import SelectField from '../selectField'

// helpers
import { getDomainNames } from '../../helpers/general'
import { makeResetPasswordDTO } from './resetPassword.helpers';

// services
import { resetPassword } from '../../services/user';

// styles
import styles from './resetPassword.module.scss'

//hooks
import { useTranslation } from 'react-i18next'

const ResetPassword = ({ showModal, handleClose, userId }) => {
  const [domainName, setDomainName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const setAsSubmitted = () => setIsSubmitting(false);
  const { t } = useTranslation()

  const handleResetPasswordSuccess = () => {
    toast.success(t('reset-password-link-sent-successfully'))
    handleClose();
  };

  const handleResetPasswordFailure = (err) => {
    toast.error(err.message)
  };

  const handleResetPassword = () => {
    const resetPasswordDTO = makeResetPasswordDTO(domainName);
    setIsSubmitting(true)
    resetPassword(resetPasswordDTO, userId)
      .then(handleResetPasswordSuccess)
      .catch(handleResetPasswordFailure)
      .finally(setAsSubmitted);
  };

  const handleDomainNameChange = (event) => {
    event?.stopPropagation();
    const { value } = event?.target || {};
    setDomainName(value);
  };
  return (
    <Dialog open={showModal} onClose={handleClose} onClick={(e) => e.stopPropagation()}>
      <DialogTitle className={styles.heading}>
        {t('reset-password-title')}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          className={styles.iconBtn}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className={styles.container}>
        <div className={styles.resetMsg}>
          {t('reset-password-lable')}
        </div>
        <SelectField
          options={getDomainNames()}
          label={t('reset-password-send-email-through')}
          id="domainName"
          value={domainName}
          error=""
          onChange={handleDomainNameChange}
        />
      </DialogContent>
      <DialogActions className={styles.actions}>
        <Button
          onClick={handleClose}
          type="submit"
          className={styles.cancelBtn}
          variant="contained"
          disabled={isSubmitting}
          sx={{ marginTop: '20px' }}
          data-testid="resetPasswordCancel"
        >
          {t('reset-password-cancel')}
        </Button>
        <Button
          onClick={handleResetPassword}
          type="submit"
          className={styles.continueBtn}
          variant="contained"
          sx={{ marginTop: '20px', marginLeft: '10px' }}
          disabled={isSubmitting || !domainName}
          data-testid="resetPasswordSubmit"
        >
          {t('reset-password-continue-to-send')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResetPassword;
